/** Кука закрытия баннера об изменениях в ипотечных программах */
export const MORTGAGE_RATE_HIKE_BANNER_CLOSED_COOKIE_NAME = 'mortgage_rate_hike_banner_closed';
export const MORTGAGE_RATE_HIKE_BANNER_CLOSED_COOKIE_VALUE = '1';
